// extracted by mini-css-extract-plugin
module.exports = {"card":"Mini_card__1afqv"};